import React, { Component } from 'react'

import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Divider from 'material-ui/Divider'
import {List, ListItem} from 'material-ui/List'

import StarsRating from 'components/StarsRating'
import Checkbox from 'material-ui/Checkbox'
import { sort, sortSev, getByType, beautifyPhone } from 'utils/stuff'



export default class ContactsBlock extends Component{
	constructor(props){
		super(props)
		this.state ={
			phoneNumber: {
				value: (props.agent)? props.agent.phoneNumber : undefined
			  , selectionStart: undefined
			}
		  , cellNumber: {
				value: (props.agent)? props.agent.cellNumber : undefined
			  , selectionStart: undefined
			}
		  , homeNumber: {
				value: (props.agent)? props.agent.homeNumber : undefined
			  , selectionStart: undefined
			}
		  , faxNumber:  {
				value: (props.agent)? props.agent.faxNumber : undefined
			  , selectionStart: undefined
			}
		  , editing: ""
		}
	}
	componentWillUpdate(){
		if(this.props.agent && (typeof this.state.phoneNumber.value != "string" || typeof this.state.cellNumber.value != "string")){
			this.setState({
				phoneNumber: {
					value: this.props.agent.phoneNumber
				  , selectionStart: this.props.agent.phoneNumber.length
				}
			  , cellNumber: {
					value: this.props.agent.cellNumber
				  , selectionStart: this.props.agent.cellNumber.length
				}
			  , homeNumber: {
					value: this.props.agent.homeNumber
				  , selectionStart: undefined
				}
			  , faxNumber:  {
					value: this.props.agent.faxNumber
				  , selectionStart: undefined
				}
			})
		}
	}
	render(){
		return(
			<div>
				<header
					style={{
						width: "100%"
					  , height: "60px"
					  , top: "0"
					  , zIndex: "5555"
					  , backgroundColor: "#00ACC1"
					  , position: "fixed"
					  , lineHeight: "60px"
					}}
					className="action-bar"
				>
					<div
						style={{
							width: "inherit"
						  , height: "inherit"
						  , textAlign: "center"
						}}
					>
						<span
							style={{
								display: "inline-block"
							  , position: "absolute"
							  , left : "4px"
							}}
							onClick={()=> this.props.setState("")}
						>
							<svg
								width="16px"
								height="16px"
								viewBox="0 0 17 17"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{
									verticalAlign: "middle"
								  , marginLeft: "12px"
								  , cursor: "pointer"
								  , paddingBottom: "3px"
								  , marginRight: "5px"
								}}
							>
								<title>Group</title>
								<defs></defs>
								<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
									<g id="Group" transform="translate(1.000000, 1.000000)" stroke="#909090" strokeWidth="2">
										<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
									</g>
								</g>
							</svg>
							Contacts
						</span>

					</div>
				</header>
				<div
					style={{
						padding: "50px 10px 20px 10px"
						, overflow: "scroll"
						, height: "100vh"
					}}
				>
					<div style={{overflow: "scroll"}}>
						<div style={{marginTop: '0px'}}>
							<div style={{
									width: (typeof global.md.phone() != 'string')? "calc(50% - 24px)" : "100%"
								  , display: (typeof global.md.phone() != 'string')? "inline-block" : "block"
								  , marginLeft: (typeof global.md.phone() != 'string')? "20px" : "16px"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.cellNumber.value}
									floatingLabelText="Mob"
									ref={`cellNumber-${this.props.agent._id}`}
									key={`${this.props.agent._id}-pn`}
									inputStyle={{fontSize: "16"}}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										if(evt.target.value.replace(/\D/g, '').length >= this.state.cellNumber.value.replace(/\D/g, '').length){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											cellNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`cellNumber-${this.props.agent._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.agent._id
											  , cellNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.agent.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change phone'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.agent.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change phone'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
										: false
									}
								/>
							</div>
							<div style={{
									width: (typeof global.md.phone() != 'string')? 'calc(50% - 24px)' : "100%"
								  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
								  , float: (typeof global.md.phone() != 'string')? "right": "none"
								  , marginLeft: (typeof global.md.phone() != 'string')? "0px" : "16px"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.phoneNumber.value}
									floatingLabelText="Work"
									key={`${this.props.agent._id}-cn`}
									inputStyle={{fontSize: "16"}}
									ref={`phoneNumber-${this.props.agent._id}`}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										if(evt.target.value.replace(/\D/g, '').length >= this.state.phoneNumber.value.replace(/\D/g, '').length){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											phoneNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`phoneNumber-${this.props.agent._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.agent._id
											  , phoneNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.agent.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change cell'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.agent.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change cell'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
											: false
									}
								/>
							</div>
							<div style={{
									width: (typeof global.md.phone() != 'string')? 'calc(50% - 24px)' : "100%"
								  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
								  , float: (typeof global.md.phone() != 'string')? "right": "none"
								  , marginLeft: (typeof global.md.phone() != 'string')? "0px" : "16px"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.homeNumber.value}
									floatingLabelText="Home"
									key={`${this.props.agent._id}-cn`}
									inputStyle={{fontSize: "16"}}
									ref={`homeNumber-${this.props.agent._id}`}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										let lengthVal = (this.state.homeNumber && this.state.homeNumber.value)? this.state.homeNumber.value.replace(/\D/g, '').length : 0
										if(evt.target.value.replace(/\D/g, '').length >= lengthVal){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											homeNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`homeNumber-${this.props.agent._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.agent._id
											  , homeNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.agent.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change number'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.agent.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change number'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
											: false
									}
								/>
							</div>
							<div style={{
									width: (typeof global.md.phone() != 'string')? 'calc(50% - 24px)' : "100%"
								  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
								  , float: (typeof global.md.phone() != 'string')? "right": "none"
								  , marginLeft: (typeof global.md.phone() != 'string')? "0px" : "16px"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.faxNumber.value}
									floatingLabelText="Fax"
									key={`${this.props.agent._id}-cn`}
									inputStyle={{fontSize: "16"}}
									ref={`faxNumber-${this.props.agent._id}`}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										let lengthVal = (this.state.faxNumber && this.state.faxNumber.value)? this.state.faxNumber.value.replace(/\D/g, '').length : 0
										if(evt.target.value.replace(/\D/g, '').length >= lengthVal){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											faxNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`faxNumber-${this.props.agent._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.agent._id
											  , faxNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.agent.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change fax'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.agent.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change fax'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
											: false
									}
								/>
							</div>
						</div>
						<div style={{
								width: (typeof global.md.phone() != 'string')? 'calc(50% - 24px)': "100%"
							  , float: (typeof global.md.phone() != 'string')? "left" : "none"
							  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
							  , marginLeft: (typeof global.md.phone() != 'string')? "0px" : "16px"
							}}
						>
							<TextField
								style={{width: "calc(100% - 42px)"}}
								defaultValue={this.props.agent.email}
								key={`${this.props.agent._id}-emal`}
								floatingLabelText="E-mail"
								inputStyle={{fontSize: "16"}}
								onBlur={(evt)=>
									(evt.target.value.length)?
										this.props.docUpd({
											_id: this.props.agent._id
											, email: evt.target.value
											, comments: (!this.props.agent.comments)?
												  [{
													  userID: this.props.login.userID
													, auto: true, body: 'Change e-mail'
													, date: new Date().valueOf()
													, value: evt.target.value
												  }]
												  : [
													  ...this.props.agent.comments
													, {
														  userID: this.props.login.userID
														, auto: true, body: 'Change e-mail'
														, date: new Date().valueOf()
														, value: evt.target.value
													  }
												  ]
										})
										: false
								}
							/>

						</div>
						<div style={{
								width: (typeof global.md.phone() != 'string')? 'calc(50% - 40px)' : "100%"
							  , float: (typeof global.md.phone() != 'string')? "right" : "none"
							  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
							  , marginLeft: (typeof global.md.phone() != 'string')? "0px" : "16px"
							}}
						>
							<TextField
								style={{width: "calc(100% - 40px)"}}
								defaultValue={this.props.agent.web}
								key={`${this.props.agent._id}-web`}
								floatingLabelText="Web"
								inputStyle={{fontSize: "16"}}
								onBlur={(evt)=>
									(evt.target.value.length)?
										this.props.docUpd({
											_id: this.props.agent._id
										  , web: evt.target.value
										  , comments: (!this.props.agent.comments)?
												[{
													userID: this.props.login.userID
												  , auto: true, body: 'Change web address'
												  , date: new Date().valueOf()
												  , value: evt.target.value
												}]
												: [
													...this.props.agent.comments
												  , {
														userID: this.props.login.userID
													  , auto: true, body: 'Change web address'
													  , date: new Date().valueOf()
													  , value: evt.target.value
													}
												]
										})
										: false
								}
							/>

						</div>
						<div style={{
								marginLeft: (typeof global.md.phone() != 'string')? "36px" : "16px"
							  , width: (typeof global.md.phone() != 'string')? 'calc(50% - 40px)' : "100%"
							}}
						>
							<div>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									defaultValue={(this.props.agent.address)? this.props.agent.address : ''}
									floatingLabelText="Address"
									multiLine={true}
									rows={2}
									key={`${this.props.agent._id}-str`}
									inputStyle={{fontSize: "16"}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.agent._id
											  , address: evt.target.value
											  , comments: (!this.props.agent.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change address'
													  , date: new Date().valueOf()
													  , value: evt.target.value
													}]
													: [
														...this.props.agent.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change address'
														  , date: new Date().valueOf()
														  , value: evt.target.value
														}
													]
											})
											: false
									}
								/>
							</div>
						</div>
						{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
							<div
								style={{width: "calc(100% - 32px)", marginLeft: "16px", marginTop: "32px"}}
							>
								<RaisedButton
									backgroundColor="#3cd2ae"
									labelColor="#FFF"
									label="OK"
									fullWidth={true}
									style={{
										height: "40px"
									  , borderRadius: "4px"
									}}
									onClick={()=> this.props.setState("")}
								/>
							</div>:""

						}
					</div>
				</div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/agentForm/ContactsBlock.js